export const TRANSPORTATION = Object.freeze({
  DROPOFF: 'DROPOFF',
  SHUTTLE: 'SHUTTLE',
  WAITER: 'WAITER',
  LOANER: 'LOANER',
  RENTAL: 'RENTAL',
  VALET: 'VALET',
  VALETLOANER: 'VALETLOANER',
  RIDESHARE: 'RIDESHARE'
});

export const TRANSPORTATION_LABEL = Object.freeze({
  DROPOFF_LABEL: 'Drop off',
  SHUTTLE_LABEL: 'Shuttle',
  WAITER_LABEL: 'Waiter',
  LOANER_LABEL: 'Loaner',
  RENTAL_LABEL: 'Rental',
  VALET_LABEL: 'Valet',
  RIDESHARE_LABEL: 'Rideshare'
});



// WEBPACK FOOTER //
// ./src/constants/transportation.js